export default __webpack_public_path__ + "static/facilatorBanner-8b5181a84abba1fe24c21721f4e07bd3.jpg";